import DotLoader from "react-spinners/DotLoader";
import "./Loader.scss"

const Loader = ({allHeight}) => {
	return (
		<div className={`flex center-content-items loader--container ${allHeight && "all-height"}`}>
			<DotLoader color="#315D9E" size="100" />
		</div>
	);
};

export default Loader;
